const config = {
  api: {
    baseUri: process.env.REACT_APP_API_URI,
    uri: process.env.REACT_APP_API_URI + '/graphql'
  },
  pti: {
    token: 'pliHLQ3vIDrC8MvDbvNoaBdoL1fNGDuV',
    issueUrl: 'https://preflighttech.com/api/1/issues',
    baseUri: process.env.REACT_APP_PTI_API_URI,
    uri: process.env.REACT_APP_PTI_API_URI + '/graphql',
  },
  app: {
    name: 'novsys-react',
    version: process.env.REACT_APP_VERSION,
    isDemo: 'true' === process.env.REACT_APP_IS_DEMO,
    isDevelopment: (
      !process.env.NODE_ENV || process.env.NODE_ENV === 'development'
    ),
    selectLanguage: 'true' === process.env.REACT_APP_SELECT_LANGUAGE,
  }
};

export default config;
